import { apiClient } from '@/shared/lib/axios';
import { AdminInsurerAttentionFilterParams } from '@/types/admin-insurer-attention';
import { getApiErrorMessage } from '@/utils';
import { CSV_ERROR_MESSAGE, CSV_SUCCESS_MESSAGE } from '@/constants/messages';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';

export const downloadInsurerAttentionCsv = async (
  siteType: string,
  query?: AdminInsurerAttentionFilterParams
): Promise<void> => {
  const response = await apiClient.get(`/admin/${siteType}/insurer-attentions/csv`, {
    params: query,
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `insurer_attentions${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const useDownloadInsurerAttentionCsv = () => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';
  const toast = useAppToast();

  return useMutation({
    mutationFn: (query?: AdminInsurerAttentionFilterParams) =>
      downloadInsurerAttentionCsv(siteType, query),
    onSuccess: () => {
      toast.success(CSV_SUCCESS_MESSAGE);
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, CSV_ERROR_MESSAGE));
    },
  });
};
